import React from "react"
import { PageProps } from "gatsby"
// layouts
import Layout from "@/layouts/layout"
// fonts
import H2 from "@/fonts/h2"
import H3 from "@/fonts/h3"
import Body_1 from "@/fonts/body_1"
import Subtitle_2 from "@/fonts/subtitle_2"
import A from "@/fonts/a"
// styles
import "@/styles/page/termsofuse.scss"

const TermsOfUse: React.FC<PageProps> = () => (
  <Layout>
    <div className="termsofuse">
      <H2>利用規約</H2>
      <div className="content">
        <H3>第1条	定義</H3>
        <Body_1>
          <ol>
            <li>当社</li>
            日本サポートシステム株式会社
            <li>本サービス</li>
            当社が提供する「ZUCO」という名称のサービス
            <li>本サイト</li>
            当社が本サービスを提供するために運営する以下のウェブサイト<br/>
            <a href="https://zuco.tech">https://zuco.tech</a>
            <li>ユーザー</li>
            本サービスの提供を受ける者
            <li>ユーザー端末等</li>
            ユーザーの端末（ソフトウェアを含みます。）、電気通信設備その他の機器
            <li>ユーザー基本情報</li>
            商号若しくは屋号又は氏名、本店若しくは主たる事業所の所在地又は住所、電話番号、メールアドレス、代表者及び担当者の氏名
            <li>ユーザーID</li>
            ユーザーが本サイトにログインするためのID
            <li>ユーザーパスワード</li>
            ユーザーが本サイトにログインするためのパスワード
            <li>ログイン情報</li>
            ユーザーID及びユーザーパスワード
            <li>ユーザープロフィール</li>
            ユーザーが本サービスを通じて本サイトに登録した自らのプロフィール
            <li>ユーザー動画</li>
            ユーザーが本サービスを通じて本サイトに投稿した動画
            <li>ユーザーコンテンツ</li>
            ユーザープロフィール、ユーザー動画、その説明文章、ユーザー動画に対するコメントその他のユーザーが登録又は投稿したコンテンツ
            <li>反社会的勢力</li>
            暴力団、暴力団員（暴力団員でなくなった時から5年を経過しない者を含みます。）、暴力団準構成員、暴力団関係企業、総会屋等、社会運動等標榜ゴロ、特殊知能暴力集団等及びこれらの者と社会的に非難される関係を有する者並びにこれらに準じる者
          </ol>
        </Body_1>

        <H3>第2条　利用規約の適用等</H3>
        <Body_1>
          <ol>
            <li>本規約は、本サービスの利用に関するユーザーと当社との間の関係を定めるものです。</li>
            <li>ユーザーが本サービスを利用した場合、ユーザーは、当社との間で、本規約を本サービスの利用に関するユーザーと当社との間の契約（以下「本契約」といいます。）の内容とすることを合意したものとみなします。</li>
            <li>ユーザーは、本契約の定めのほか、当社が定めるルール、ガイドラインその他の当社が定める事項を遵守するものとします。</li>
          </ol>
        </Body_1>

        <H3>第2条　本サービスの目的及び内容</H3>
        <Body_1>
          <ol>
            <li>本サービスは、ユーザーがものづくりに関するユーザー動画を投稿し、そのユーザー動画を他のユーザーが視聴し、ユーザー同士がコミュニケーションを行うことが可能な場を提供することにより、それぞれのユーザーの「ものづくり」に関する知見、ノウハウ等の共有、蓄積等を通じて、我が国のものづくり業界を発展させることを目的とします。</li>
            <li>本サービスの内容は、次の各号に掲げる機能として当社が定めるものをいいます。</li>
            <ol>
              <li>ユーザーがユーザー登録を経ないで利用することができるサービス</li>
              <ol>
                <li>ユーザー動画の検索</li>
                <li>ユーザー動画の視聴</li>
                <li>ユーザープロフィールの閲覧</li>
                <li>その他当社が定める機能</li>
              </ol>
              <li>ユーザー登録を経たユーザー（以下「登録ユーザー」といいます。）のみが利用することができるサービス（以下「登録ユーザー向けサービス」といいます。）</li>
              <ol>
                <li>ユーザープロフィールの登録及びその編集</li>
                <li>ユーザー動画の投稿及びその削除</li>
                <li>ユーザー動画の説明文章の作成並びにその編集及び削除</li>
                <li>他のユーザーが投稿したユーザー動画に対するコメント等の投稿</li>
                <li>他のユーザーのフォロー（フォローの対象とされた他のユーザーがユーザー動画を投稿した場合にその旨の連絡を受領することができる機能など）</li>
                <li>その他当社が定める機能</li>
              </ol>
              <li>その他当社が定める機能</li>
            </ol>
            <li>ユーザーは、本契約に定める条件及び法令等の規定を遵守して本サービスを利用するものとします。</li>
            <li>本サービスは、ものづくりに関するユーザー動画の投稿、視聴、ユーザー同士のコミュニケーションを行うことが可能な場を提供するものであって、それぞれのユーザーは、自らの責任において本サービスを利用するものとし、当社は、それぞれのユーザーの行為及びその結果について責任を負うものではありません。</li>
          </ol>
        </Body_1>

        <H3>第4条　利用環境</H3>
        <Body_1>
          <ol>
            <li>ユーザーは、自らの責任と負担において、本サービスを利用するために必要なユーザー端末等を用意し、インターネットに接続することが可能な環境を整えて本サービスを利用するものとします。</li>
            <li>ユーザーは、本サービスの利用に当たり、自らの責任と負担において、ユーザーのユーザー端末等について、有害なプログラムへの感染、不正アクセス、情報の漏洩等を防止するための安全対策を講じるものとします。</li>
            <li>ユーザーは、本サービスの利用に関連する情報のバックアップが必要であるときは、自らの責任と負担においてバックアップを行うものとします。</li>
          </ol>
        </Body_1>

        <H3>第5条　ユーザー登録</H3>
        <Body_1>
          <ol>
            <li>ユーザーは、登録ユーザー向けサービスを利用するためには、当社が定める方法により申し込み、ユーザー基本情報を登録するとともにユーザーパスワードを設定し、当社がユーザーに対して登録ユーザー向けサービスの利用を承認すること（以下「ユーザー登録」といいます。）が必要です。</li>
            <li>ユーザー登録は、ユーザー本人（ユーザーが法人の場合にあっては代表者又は必要な代理権を付与された者）のみが行うことができるものとします。</li>
            <li>次の各号に掲げるユーザーは、ユーザー登録を受けることができません。</li>
            <ol>
              <li>未成年者（あらかじめ親権者の同意を得たことを示す合理的な証拠を提出した者を除く。）</li>
              <li>既にユーザー登録を受けている者又はこれと実質的に同一と当社が判断した者</li>
              <li>過去に本サービス又は当社が提供する他のサービスについて利用停止、ユーザー登録の抹消、契約の解除等の措置を受けたことがある者</li>
              <li>本契約に定める条件又は法令等の規定に違反するおそれがあると当社が判断した者</li>
              <li>日本国以外に居住している者</li>
              <li>反社会的勢力又はその可能性があると当社が判断した者</li>
              <li>その他ユーザー登録が相当でないと当社が合理的に判断した者</li>
            </ol>
            <li>ユーザーは、ユーザー基本情報として真実かつ正確な情報を登録するものとします。</li>
            <li>ユーザーは、常にユーザー基本情報を最新の状態に保つものとし、ユーザー基本情報の全部又は一部に変更が生じたときは、直ちに当社が定める方法により変更後の内容を登録するものとします。</li>
            <li>現に登録されているユーザー基本情報が真実かつ正確な最新のものでない可能性があると当社が判断したときは、当社は、ユーザーに対し、ユーザー基本情報が真実かつ正確な最新のものであることを示す合理的な資料を提出するとともに、ユーザー基本情報が真実かつ正確な最新のものとなるよう変更することを請求することができるものとし、ユーザーは、当社の請求に異議なく応じるものとします。</li>
            <li>現に登録されているユーザー基本情報が真実かつ正確な最新のものでないことにより当社のユーザーに対する通知が延着したとき又は到着しなかったときは、当社が当該通知を発した時点で登録されていたユーザー基本情報を基準として通常到着すべき時までに到着したものとみなします。</li>
          </ol>
        </Body_1>

        <H3>第6条　ID及びパスワード等の管理</H3>
        <Body_1>
          <ol>
            <li>ユーザーがユーザー登録を完了したときは、当社は、ユーザーに対し、本サービスの利用に必要なユーザーIDを付与します。</li>
            <li>ユーザーは、ログイン情報の管理に関する一切の責任を負うものとします。本サイトにおいて入力されたログイン情報がユーザーのログイン情報と一致するときは、当該ユーザーが本サービスを利用したものとみなします。</li>
            <li>ユーザーは、第三者に対してログイン情報を使用させてはならないものとします。ユーザーは、自らのログイン情報が第三者に使用されたとき、又は、そのおそれがあるときは、直ちに当社に対して連絡するものとします。</li>
            <li>ユーザーは、本サービスの利用に関連するユーザー端末等にパスコード、本人認証その他の措置を講じることにより、ユーザー端末等が第三者に使用されることがないようにするものとします。</li>
            <li>ユーザーは、本サービスを利用するユーザー端末等を紛失し、又は、盗難その他の被害に遭ったときは、直ちに当社に対して連絡するとともに、自らの責任と負担において当該ユーザー端末等のロックその他の第三者に使用されることがないようにする措置を講じるものとします。</li>
          </ol>
        </Body_1>

        <H3>第7条　ユーザーコンテンツに関する事項</H3>
        <Body_1>
          <ol>
            <li>ユーザーは、当社に対し、本サイトに登録又は投稿する一切のユーザーコンテンツについて、自らが登録又は投稿を行う権利を有し、また、他のユーザー、当社その他の第三者の知的財産権その他の権利又は利益を一切侵害していないことを表明し、保証します。</li>
            <li>ユーザーは、当社に対し、本サイトに登録又は投稿する一切のユーザーコンテンツについて、無償で、世界的、非独占的、サブライセンス可能かつ譲渡可能なライセンスを付与します。このライセンスの対象には、本サービスその他の当社の事業に関してユーザーコンテンツを使用・利用すること（複製、公衆送信等、上演、上映、頒布、譲渡、翻訳、翻案、派生的コンテンツの作成及びその使用・利用を含みます。）が含まれます。これらのライセンスは、対象となるユーザーコンテンツが削除された後も有効に存続するものとします。</li>
            <li>ユーザーは、他のユーザーに対し、本サイトに登録又は投稿する一切のユーザーコンテンツについて、無償で、本サービスの機能の範囲内でのみ可能な方法により使用・利用すること（複製、公衆送信等、派生的コンテンツの作成及びその使用・利用を含みます。）を対象とする世界的、非独占的なライセンスを付与します。</li>
            <li>ユーザーは、本サイトに登録又は投稿する一切のユーザーコンテンツについて、当社及び他のユーザーに対し、前2項に定めるライセンスに基づくユーザーコンテンツの使用・利用について著作者人格権を行使せず、また、第三者をして行使させないことを確約します。</li>
          </ol>
        </Body_1>

        <H3>第8条　他の動画投稿サービスに投稿された動画を投稿する場合に関する事項</H3>
        <Body_1>
          <ol>
            <li>ユーザーは、<a href="https://www.youtube.com" target="_blank">YouTube</a>その他の他の動画投稿サービスに投稿された動画をユーザー動画として投稿するときは、<a href="https://www.youtube.com/t/terms" target="_blank">YouTube利用規約</a>その他の当該他の動画投稿サービスの運営事業者の規約その他の契約に定める条件及び法令の規定を遵守し、それらの条件及び規定に一切違反しない方法によってのみ投稿することができるものとします。この場合、第7条（ユーザーコンテンツに関する事項）第3項の定めにかかわらず、ユーザーの他のユーザーに対するライセンスの対象は、それらの条件及び規定に違反しない範囲内における当該ユーザー動画の視聴のみとします。</li>
            <li>ユーザーが前項の定めに違反してユーザー動画を投稿し、又は、そのおそれがあると当社が判断したときは、当社は、いつでも、その裁量により当該ユーザー動画を削除することができるものとします。</li>
            <li>ユーザーが第1項の定めに違反したか否かを問わず、YouTubeその他の他の動画投稿サービスの運営事業者その他の第三者の要請等があったときは、当社は、当該要請等に従い、その対象であるユーザー動画を削除することができるものとします。</li>
            <li>ユーザーが第1項の定めに違反したか否かを問わず、YouTubeその他の他の動画投稿サービスの運営事業者が自らユーザー動画の削除等を行った場合であっても、当社は、当該ユーザー動画を投稿したユーザーに対し、当該ユーザー動画が投稿された状態の回復に向けて措置を講じる義務を一切負いません。</li>
          </ol>
        </Body_1>

        <H3>第9条　本サービスのコンテンツに関する事項</H3>
        <Body_1>
          &emsp;本サイトを含む本サービスを構成する全てのコンテンツに関する知的財産権その他の権利は、当社又は当該権利を有する第三者に帰属するものとし、ユーザーは、当社が定める方法に従って本サービスを利用する限度でのみこれらのコンテンツを利用することができるものとします。
        </Body_1>

        <H3>第10条　禁止事項</H3>
        <Body_1>
          &emsp;ユーザーは、本サービスの利用に際し、次の各号に定める事由のいずれかに該当し、又は、該当するおそれがあると当社が判断する行為をしてはならないものとします。
          <ol>
            <li>第5条（ユーザー登録）第3項各号に定める事由のいずれかに該当するにもかかわらずユーザー登録を申し込む行為</li>
            <li>ユーザー登録後に第5条（ユーザー登録）第3項各号に定める事由のいずれかに該当するに至ったにもかかわらず登録ユーザー向けサービスを利用し、又は、ユーザー登録を維持する行為</li>
            <li>違法又は不正な目的をもって本サービスを利用する行為</li>
            <li>当社から利用停止、ユーザー登録の抹消等を受けたにもかかわらず、本サービスを利用する行為</li>
            <li>第三者になりすまして本サービスを利用する行為</li>
            <li>第三者に対して自らのログイン情報を使用させる行為</li>
            <li>他のユーザーのログイン情報を収集する行為</li>
            <li>真実若しくは正確でない情報又は最新でない情報を登録又は申告する行為</li>
            <li>違法又は不正な手段により入手した情報を登録又は申告する行為</li>
            <li>本サービスの利用を通じて入手した第三者に関する情報を第三者に開示する行為</li>
            <li>本サービスの目的に沿わないユーザーコンテンツの登録又は投稿</li>
            <li>次のいずれかに該当するユーザーコンテンツの登録又は投稿</li>
            <ol>
              <li>暴力的又は残虐な表現を含む情報</li>
              <li>わいせつな表現を含む情報</li>
              <li>差別を助長する表現を含む情報</li>
              <li>自殺、自傷等を助長する表現を含む情報</li>
              <li>薬物の違法又は不適切な使用等を助長する表現を含む情報</li>
              <li>スパム等の第三者に対する情報の拡散を求める情報</li>
              <li>第三者（他のユーザーを含みます。）に不快感を与える表現を含む情報</li>
              <li>第三者（他のユーザーを含みます。）の財産、知的財産権、肖像権、プライバシー、企業秘密、名誉、名誉感情、信用、肖像権その他の権利又は利益を害する表現を含む情報</li>
              <li>公序良俗に反する表現を含む情報</li>
              <li>その他の違法、反社会的又は不適切な表現を含む情報</li>
            </ol>
            <li>コンピューター・ウィルスその他の有害なプログラムを使用する行為</li>
            <li>本サービスに関連するシステムに対して不正にアクセスし、又は、本サービスに関連するシステム上の情報を不正に取得し、若しくは、改竄する行為</li>
            <li>本サービスに関連するサーバー等に過度の負担をかける行為その他の本サービスの提供に支障を生じさせる行為</li>
            <li>本サービスに関連するソフトウェアについてリバースエンジニアリング、デコンパイル若しくは逆アセンブルを加える行為又はこれらに類似する行為</li>
            <li>人工知能その他の自動化された手段を使用して本サービスを利用する行為</li>
            <li>当社又は本サービスに関連する第三者（他のユーザーを含みます。）の財産、知的財産権、肖像権、プライバシー、企業秘密その他の権利又は利益を侵害する行為</li>
            <li>当社又は本サービスに関連する第三者（他のユーザーを含みます。）に対して信用若しくは名誉を毀損し、侮辱し、誹謗中傷その他の不快感、嫌悪感、悪感情等を与える行為</li>
            <li>当社又は本サービスに関連する第三者の事業その他の活動を妨害する行為</li>
            <li>面識のない異性との連絡等を目的とする行為</li>
            <li>犯罪的行為又は犯罪的行為に結び付く行為</li>
            <li>法令又は公序良俗に違反する行為</li>
            <li>前各号のいずれかに該当する行為を誘発又は助長する行為</li>
            <li>その他、本契約に違反する行為</li>
          </ol>
        </Body_1>

        <H3>第11条　再委託</H3>
        <Body_1>
          &emsp;当社は、第三者に対し、本サービスの一部を再委託することができるものとします。
        </Body_1>

        <H3>第12条　本サービスの内容の変更</H3>
        <Body_1>
          &emsp;当社は、いつでも、本サービスの内容（本サイトの機能を含みます。）の全部又は一部を変更することができるものとします。
        </Body_1>

        <H3>第13条　本サービスの提供の一時的中断・制限</H3>
        <Body_1>
          &emsp;当社は、次の各号に定める事由に該当するときは、あらかじめユーザーに事前に通知することなく、本サービスの全部又は一部の提供を一時的に中断又は制限することができるものとします。
          <ol>
            <li>本サービスに関連するシステム、設備の保守、点検、更新等を行う場合</li>
            <li>本サービスに関連するシステム、サーバー等のダウンの回避に必要な場合</li>
            <li>地震、落雷、火災、停電、天災地変、通信障害、感染症その他の当社の責めに帰することができない事由により本サービスを提供することが困難となった場合</li>
            <li>その他、当社が必要と判断した場合</li>
          </ol>
        </Body_1>


        <H3>第14条	利用停止等</H3>
        <Body_1>
          &emsp;登録ユーザーが次の各号に定める事由のいずれかに該当するときは、当社は、登録ユーザーに対する通知その他の手続を要することなく、直ちに本サービスの利用停止その他の必要な措置をとることができるものとします。
          <ol>
            <li>第10条（禁止事項）各号に定める事由のいずれかに該当し、又は、該当するおそれがあると当社が判断した場合</li>
            <li>当社からの回答を求める通知に対して14日以上返答がない場合</li>
            <li>本サイトへのログインが3か月以上ない場合</li>
            <li>その他、本契約の定めに違反し、又は、そのおそれがあると当社が判断した場合</li>
          </ol>
        </Body_1>

        <H3>第15条	退会</H3>
        <Body_1>
          <ol>
            <li>登録ユーザーは、いつでも、当社が指定する方法により退会することができるものとします。</li>
            <li>登録ユーザーは、退会したときは、本サービスに関する一切の権利及び利益（本サービスに関連する特典その他の経済上又は事実上の利益を含みます。）を失うものとします。</li>
          </ol>
        </Body_1>

        <H3>第16条	登録抹消</H3>
        <Body_1>
          <ol>
            <li>登録ユーザーが本契約の定めに違反し、当社が当該登録ユーザーに対してその違反の是正を求めたにもかかわらず7日以内にその違反が是正されないときは、当社は、当該登録ユーザーのユーザー登録を抹消することができるものとします。</li>
            <li>前項の定めにかかわらず、登録ユーザーが次の各号に定める事由のいずれかに該当するときは、当社は、当該登録ユーザーに対する催告その他の手続を要することなく、直ちに当該登録ユーザーのユーザー登録を抹消することができるものとします。</li>
            <ol>
              <li>第10条（禁止事項）各号に定める事由に該当する場合</li>
              <li>当社からの回答を求める通知に対して30日以上返答がない場合</li>
              <li>本サイトへのログインが6か月以上ない場合</li>
              <li>破産手続、再生手続、会社更生手続、特別清算手続又はこれらに準じる手続の申立てがあった場合</li>
              <li>支払停止又は支払不能となった場合</li>
              <li>手形又は小切手が不渡りとなった場合</li>
              <li>仮差押えその他の保全処分、差押えその他の強制執行若しくは競売その他の担保権の実行の申立て又は公租公課の滞納処分を受けた場合</li>
              <li>事業又は信用の状態が本サービスの利用に適当でないと当社が判断した場合</li>
              <li>監督官庁から業務停止又は免許若しくは登録の取消しの処分を受けた場合</li>
              <li>資本金の額の減少、事業譲渡、合併、会社分割又は解散の決議をした場合</li>
              <li>ユーザーが自然人である場合にあっては、未成年であることが判明した場合</li>
              <li>ユーザーが自然人である場合にあっては、死亡した場合</li>
              <li>その他、本契約に違反した場合</li>
            </ol>
            <li>登録ユーザーは、前2項の定めによりユーザー登録を抹消されたときは、本サービスに関する一切の権利及び利益（本サービスに関連する特典その他の経済上又は事実上の利益を含みます。）を失うものとします。</li>
          </ol>
        </Body_1>

        <H3>第17条	本サービスの終了</H3>
        <Body_1>
          <ol>
            <li>当社は、本サービスの提供を終了するときは、あらかじめ、ユーザーに対し、本サービスを終了する旨を通知し、又は、本サイトに掲載するなどして周知するものとします。</li>
            <li>当社が本サービスの提供を終了したときは、本契約は解約されたものとします。この場合、本契約は、将来に向かってのみ効力を失うものとします。</li>
          </ol>

        </Body_1>

        <H3>第18条	損害賠償等</H3>
        <Body_1>
          <ol>
            <li>ユーザーが本契約に違反したことにより当社又は第三者に損害（調査費用、弁護士費用等の専門家費用を含みます。）が生じたときは、ユーザーは、当社又は第三者に対し、当該損害を賠償する責任を負うものとします。</li>
            <li>当社がユーザーに対して損害を賠償する責任を負う場合、その責任の範囲は、ユーザーに直接かつ現実に生じた通常の損害に限られるものとし、かつ、当社がユーザーに対して負う損害賠償義務の上限は、①当該損害の発生の日から起算して過去１年間にユーザー及び当社の一方が他方に支払った対価に相当する金額の月額平均、又は、②金3万円のいずれか高い方の金額とします。</li>
          </ol>

        </Body_1>

        <H3>第19条	非保証</H3>
        <Body_1>
          &emsp;当社は、次の各号に定める事項のいずれについても、一切保証しません。
          <ol>
            <li>本サイトの動作にバグ、エラー、システム障害その他の不具合が生じないこと</li>
            <li>本サイトにセキュリティ上の欠陥がないこと</li>
            <li>本サービスに関連するシステムに不正なアクセス等がないこと</li>
            <li>本サイトを含む本サービスを構成する一切のコンテンツの適法性、正確性、完全性、最新性、信頼性、有用性、妥当性その他一切の事項</li>
            <li>本サイトを含む本サービスを構成する一切のコンテンツが消失しないこと</li>
            <li>本サイトを含む本サービスを構成する一切のコンテンツのバックアップ</li>
            <li>本サイトを含む本サービスを構成する一切のコンテンツ、本サービスに関連するシステム、当社がユーザーに対して送付するメール等にコンピューター・ウィルスその他の有害なプログラム等が含まれないこと</li>
            <li>本サービスの内容がユーザーの期待する品質を満たすこと</li>
          </ol>

        </Body_1>

        <H3>第20条	免責</H3>
        <Body_1>
          &emsp;当社は、次の各号に定める事由によりユーザーに生じた損害のいずれについても一切責任を負いません。
          <ol>
            <li>ユーザーが本契約に違反したこと</li>
            <li>当社が本サービスの全部又は一部の提供を一時的に中断又は制限したこと</li>
            <li>当社が本サービスの内容を変更したこと</li>
            <li>当社が本サービスの提供を終了したこと</li>
            <li>当社がユーザーに対して利用停止その他の措置を講じたこと</li>
            <li>当社がユーザー登録を抹消したこと</li>
            <li>当社の故意又は重過失によらない事由</li>
            <li>本サイトに含まれる第三者のウェブサイト等のリンク先に関連する事由</li>
            <li>ユーザーと第三者（他のユーザーを含みます。）との間の一切のトラブル</li>
            <li>ユーザーによる本サービスの利用に起因又は関連する事由</li>
            <li>ユーザーの責めに帰すべき事由</li>
          </ol>

        </Body_1>

        <H3>第21条	個人情報の取扱い</H3>
        <Body_1>
          <ol>
            <li>ユーザーは、本サービスの利用に関連して取得した個人情報の取扱いについて、個人情報の保護に関する法律及び当該法律に関連するガイドラインを遵守するものとします。</li>
            <li>当社は、当社が別途定める<a href="https://zuco.tech/service/privacypolicy">プライバシーポリシー</a>に基づき、ユーザーが本サービスを利用することにより当社が取得する個人情報を適切に取り扱うものとします。</li>
          </ol>

        </Body_1>

        <H3>第22条	監視等</H3>
        <Body_1>
          &emsp;ユーザーは、当社が本サービスに関して不正検知その他の理由により必要と判断したときは、ユーザーコンテンツを対象として監視、調査、分析その他の必要な措置を講じることに同意するものとします。
        </Body_1>

        <H3>第23条	契約上の地位の譲渡等の禁止等</H3>
        <Body_1>
          <ol>
            <li>ユーザーは、本契約上の地位、又は、本契約若しくは本サービスの利用に基づき発生する権利若しくは義務を、第三者に譲渡若しくは貸与してはならず、また、担保に供するなどして処分してはならないものとします。</li>
            <li>当社は、当社が第三者に対して本サービスに係る事業を譲渡するときは、当該事業の譲渡に伴い、当該第三者に本契約上の地位、本契約に基づく権利及び義務、ユーザーが本サービスの利用に関連して登録した情報等を譲渡することができるものとし、ユーザーは、これらの譲渡について、あらかじめ異議なく承諾するものとします。</li>
          </ol>

        </Body_1>

        <H3>第24条	利用規約の変更</H3>
        <Body_1>
          <ol>
            <li>当社は、いつでも、本規約の全部又は一部を変更することができるものとします。</li>
            <li>当社は、本規約を変更するときは、本規約を変更する旨及び変更後の本規約の内容並びにその効力発生時期を当社が定める方法により周知するものとします。</li>
            <li>本規約の変更後にユーザーが本サービスを利用したときは、ユーザーは、本規約の変更に同意したものとみなします。</li>
          </ol>

        </Body_1>

        <H3>第25条	分離可能性</H3>
        <Body_1>
          &emsp;本規約を含む本契約の一部が裁判所の判決等により無効と判断された場合であっても、当該一部のみが無効となり、その他の部分はなお有効に存続するものとします。
        </Body_1>

        <H3>第26条	お問合せ</H3>
        <Body_1>
          &emsp;ユーザーの当社に対する本サービスに関連する問合せは、当社が本サイトにおいて指定するメールアドレスへのご連絡その他の当社が定める方法を利用して行うものとします。
        </Body_1>

        <H3>第27条	誠実協議</H3>
        <Body_1>
          &emsp;本規約を含む本契約に定めのない事項又は本規約を含む本契約の解釈に疑義が生じた事項は、ユーザーと当社とが誠実に協議して解決するものとします。
        </Body_1>

        <H3>第28条	準拠法</H3>
        <Body_1>
          &emsp;本規約を含む本契約は、日本法に準拠し、これに従い解釈されるものとします。
        </Body_1>

        <H3>第29条	専属的合意管轄</H3>
        <Body_1>
          &emsp;本規約を含む本契約に関連する一切の紛争は、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
        </Body_1>


        <Subtitle_2>【2021年1月25日制定】</Subtitle_2>
      </div>

    </div>
  </Layout >
)

export default TermsOfUse
